import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/_user/organization/')({
  beforeLoad: () => {
    throw redirect({ to: '/organization/organization-profile' })
  },
})
